import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'

const Section = styled.section`
  max-width: 1000px;
  h2 + p {
    margin-bottom: 2.5rem;
    text-align: center;
  }
`

const SchedulePage = ({ data }) => (
  <Section>
    <h2>Schedule</h2>
    <p>Schedule subject to change</p>
    <table>
      <thead>
        <tr>
          <th>Time</th>
          <th>Talk</th>
        </tr>
      </thead>
      <tbody>
        {data.allScheduleCsv.edges.map(({ node }, i) => (
          <tr key={i}>
            <td>
              {node.from}&ndash;{node.to}
            </td>
            {node.slug ? (
              <td>
                <h3>{node.session}</h3>
                By <Link to={`/speakers#${node.slug}`}>{node.speaker}</Link>
              </td>
            ) : (
              <td>
                {node.session}
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </Section>
)

export default SchedulePage

export const query = graphql`
  query ScheduleQuery {
    allScheduleCsv {
      edges {
        node {
          from
          to
          session
          speaker
          slug
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/schedule.js